"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.simulateTransaction = exports.sendSignAndConfirmTransactions = exports.sendAndConfirmSignedTransaction = exports.awaitTransactionSignatureConfirmation = void 0;
var web3_js_1 = require("@solana/web3.js");
var bs58 = require("bs58");
var tools_1 = require("./tools");
var globalTypes_1 = require("./globalTypes");
/**
 * waits for transaction confirmation
 * @param timeoutStrategy TimeStrategy | BlockHeightStrategy
 *
 * TimeStrategy: pure timeout strategy
 *
 *  timeout: optional, (secs) after how much secs not confirmed transaction will be considered timeout, default: 90
 *  getSignatureStatusesPoolIntervalMs: optional, (ms) pool interval of getSignatureStatues, default: 2000
 *
 *
 * BlockHeightStrategy: blockheight pool satrategy
 *
 *  startBlockCheckAfterSecs: optional, (secs) after that time we will start to pool current blockheight and check if transaction will reach blockchain, default: 90
 *  block: BlockhashWithExpiryBlockHeight
 *  getSignatureStatusesPoolIntervalMs: optional, (ms) pool interval of getSignatureStatues and blockheight, default: 2000
 * @param config.logFlowInfo when true it will console log process of processing transactions
 */
var awaitTransactionSignatureConfirmation = function (_a) {
    var txid = _a.txid, confirmLevel = _a.confirmLevel, connection = _a.connection, timeoutStrategy = _a.timeoutStrategy, config = _a.config;
    return __awaiter(void 0, void 0, void 0, function () {
        var logger, timeoutConfig, timeoutBlockHeight, timeout, startTimeoutCheck, done, confirmLevels, subscriptionId, result;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    logger = new tools_1.Logger(__assign({}, config));
                    timeoutConfig = (0, globalTypes_1.getTimeoutConfig)(timeoutStrategy);
                    timeoutBlockHeight = 0;
                    timeout = 0;
                    if (timeoutConfig instanceof globalTypes_1.BlockHeightStrategyClass) {
                        timeoutBlockHeight = timeoutConfig.block.lastValidBlockHeight + tools_1.MAXIMUM_NUMBER_OF_BLOCKS_FOR_TRANSACTION;
                        timeout = timeoutConfig.startBlockCheckAfterSecs;
                    }
                    else {
                        timeout = timeoutConfig.timeout;
                    }
                    startTimeoutCheck = false;
                    done = false;
                    confirmLevels = ['finalized'];
                    if (confirmLevel === 'confirmed') {
                        confirmLevels.push('confirmed');
                    }
                    else if (confirmLevel === 'processed') {
                        confirmLevels.push('confirmed');
                        confirmLevels.push('processed');
                    }
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            (function () { return __awaiter(void 0, void 0, void 0, function () {
                                var retrySleep;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            setTimeout(function () {
                                                if (done) {
                                                    return;
                                                }
                                                if (timeoutBlockHeight !== 0) {
                                                    startTimeoutCheck = true;
                                                }
                                                else {
                                                    done = true;
                                                    logger.log('Timed out for txid: ', txid);
                                                    reject({ timeout: true });
                                                }
                                            }, timeout);
                                            try {
                                                subscriptionId = connection.onSignature(txid, function (result, context) {
                                                    subscriptionId = undefined;
                                                    done = true;
                                                    if (result.err) {
                                                        reject(result.err);
                                                    }
                                                    else {
                                                        resolve(result);
                                                    }
                                                }, confirmLevel);
                                            }
                                            catch (e) {
                                                done = true;
                                                logger.log('WS error in setup', txid, e);
                                            }
                                            retrySleep = timeoutConfig.getSignatureStatusesPoolIntervalMs || 5000;
                                            _a.label = 1;
                                        case 1:
                                            if (!!done) return [3 /*break*/, 3];
                                            // eslint-disable-next-line no-loop-func
                                            return [4 /*yield*/, (0, tools_1.sleep)(retrySleep)];
                                        case 2:
                                            // eslint-disable-next-line no-loop-func
                                            _a.sent();
                                            (function () { return __awaiter(void 0, void 0, void 0, function () {
                                                var promises, _a, signatureStatuses, currentBlockHeight, result_1, e_1;
                                                return __generator(this, function (_b) {
                                                    switch (_b.label) {
                                                        case 0:
                                                            _b.trys.push([0, 2, , 3]);
                                                            promises = [
                                                                connection.getSignatureStatuses([txid]),
                                                            ];
                                                            //if startTimeoutThreshold passed we start to check if
                                                            //current blocks are did not passed timeoutBlockHeight threshold
                                                            if (startTimeoutCheck) {
                                                                promises.push(connection.getBlockHeight('confirmed'));
                                                            }
                                                            return [4 /*yield*/, Promise.all(promises)];
                                                        case 1:
                                                            _a = _b.sent(), signatureStatuses = _a[0], currentBlockHeight = _a[1];
                                                            if (typeof currentBlockHeight !== undefined && timeoutBlockHeight <= currentBlockHeight) {
                                                                logger.log('Timed out for txid: ', txid);
                                                                done = true;
                                                                reject({ timeout: true });
                                                            }
                                                            result_1 = signatureStatuses && signatureStatuses.value[0];
                                                            if (!done) {
                                                                if (!result_1)
                                                                    return [2 /*return*/];
                                                                if (result_1.err) {
                                                                    logger.log('REST error for', txid, result_1);
                                                                    done = true;
                                                                    reject(result_1.err);
                                                                }
                                                                else if (!(result_1.confirmations || confirmLevels.includes(result_1.confirmationStatus))) {
                                                                    logger.log('REST not confirmed', txid, result_1);
                                                                }
                                                                else {
                                                                    logger.log('REST confirmed', txid, result_1);
                                                                    done = true;
                                                                    resolve(result_1);
                                                                }
                                                            }
                                                            return [3 /*break*/, 3];
                                                        case 2:
                                                            e_1 = _b.sent();
                                                            if (!done) {
                                                                logger.log('REST connection error: txid', txid, e_1);
                                                            }
                                                            return [3 /*break*/, 3];
                                                        case 3: return [2 /*return*/];
                                                    }
                                                });
                                            }); })();
                                            return [3 /*break*/, 1];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); })();
                        })];
                case 1:
                    result = _b.sent();
                    if (subscriptionId) {
                        connection.removeSignatureListener(subscriptionId).catch(function (e) {
                            logger.log('WS error in cleanup', e);
                        });
                    }
                    done = true;
                    return [2 /*return*/, result];
            }
        });
    });
};
exports.awaitTransactionSignatureConfirmation = awaitTransactionSignatureConfirmation;
/**
 * send and waits for transaction to confirm
 * @param callbacks sets of callbacks.
 * @param callbacks.postSendTxCallback post send transaction callback
 * @param callbacks.afterTxConfirmation runs after tx confirmation
 * @param timeoutStrategy TimeStrategy | BlockHeightStrategy
 *
 * TimeStrategy: pure timeout strategy
 *
 *  timeout: optional, (secs) after how much secs not confirmed transaction will be considered timeout, default: 90
 *  getSignatureStatusesPoolIntervalMs: optional, (ms) pool interval of getSignatureStatues, default: 5000
 *
 *
 * BlockHeightStrategy: blockheight pool satrategy
 *
 *  startBlockCheckAfterSecs: optional, (secs) after that time we will start to pool current blockheight and check if transaction will reach blockchain, default: 90
 *  block: BlockhashWithExpiryBlockHeight
 *  getSignatureStatusesPoolIntervalMs: optional, (ms) pool interval of getSignatureStatues and blockheight, default: 2000
 *
 * @param config.resendTxUntilConfirmed force resend transaction in the mean time of waiting for confirmation, default false
 * @param config.resendPoolTimeMs when resendTxUntilConfirmed is true it will resend transaction every value of ms until there is timeout, default 2000
 * @param config.logFlowInfo when true it will console log process of processing transactions
 * @param config.skipPreflight
 */
var sendAndConfirmSignedTransaction = function (_a) {
    var signedTransaction = _a.signedTransaction, _b = _a.confirmLevel, confirmLevel = _b === void 0 ? 'processed' : _b, connection = _a.connection, callbacks = _a.callbacks, timeoutStrategy = _a.timeoutStrategy, config = _a.config;
    return __awaiter(void 0, void 0, void 0, function () {
        var logger, timeoutConfig, resendTimeout, rawTransaction, txid, startTime, done, err_1, simulateResult, e_2, i, line;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    logger = new tools_1.Logger(__assign({}, config));
                    timeoutConfig = (0, globalTypes_1.getTimeoutConfig)(timeoutStrategy);
                    resendTimeout = 0;
                    if (timeoutConfig instanceof globalTypes_1.BlockHeightStrategyClass) {
                        resendTimeout = timeoutConfig.startBlockCheckAfterSecs;
                    }
                    else {
                        resendTimeout = timeoutConfig.timeout;
                    }
                    if (config === null || config === void 0 ? void 0 : config.resendTxUntilConfirmed) {
                        config.resendPoolTimeMs || (config.resendPoolTimeMs = 2000);
                    }
                    rawTransaction = signedTransaction.serialize();
                    txid = bs58.encode(signedTransaction.signatures[0].signature);
                    startTime = (0, tools_1.getUnixTs)();
                    return [4 /*yield*/, connection.sendRawTransaction(rawTransaction, {
                            skipPreflight: (config === null || config === void 0 ? void 0 : config.skipPreflight) === undefined ? true : config.skipPreflight,
                        })];
                case 1:
                    txid = _c.sent();
                    if (callbacks === null || callbacks === void 0 ? void 0 : callbacks.postSendTxCallback) {
                        try {
                            callbacks.postSendTxCallback({ txid: txid });
                        }
                        catch (e) {
                            logger.log("postSendTxCallback error ".concat(e));
                        }
                    }
                    done = false;
                    if (config === null || config === void 0 ? void 0 : config.resendTxUntilConfirmed) {
                        (function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(!done && (0, tools_1.getUnixTs)() - startTime < resendTimeout)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, (0, tools_1.sleep)((config === null || config === void 0 ? void 0 : config.resendPoolTimeMs) || 2000)];
                                    case 1:
                                        _a.sent();
                                        connection.sendRawTransaction(rawTransaction, {
                                            skipPreflight: (config === null || config === void 0 ? void 0 : config.skipPreflight) === undefined ? true : config.skipPreflight,
                                        });
                                        return [3 /*break*/, 0];
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); })();
                    }
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 4, 9, 10]);
                    return [4 /*yield*/, (0, exports.awaitTransactionSignatureConfirmation)({
                            txid: txid,
                            timeoutStrategy: timeoutStrategy,
                            confirmLevel: confirmLevel,
                            connection: connection,
                            config: config,
                        })];
                case 3:
                    _c.sent();
                    if (callbacks === null || callbacks === void 0 ? void 0 : callbacks.afterTxConfirmation) {
                        callbacks.afterTxConfirmation();
                    }
                    return [3 /*break*/, 10];
                case 4:
                    err_1 = _c.sent();
                    logger.log(err_1);
                    if (err_1.timeout) {
                        throw { txid: txid };
                    }
                    simulateResult = null;
                    _c.label = 5;
                case 5:
                    _c.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, simulateTransaction(connection, signedTransaction, 'single', config === null || config === void 0 ? void 0 : config.logFlowInfo)];
                case 6:
                    simulateResult = (_c.sent()).value;
                    return [3 /*break*/, 8];
                case 7:
                    e_2 = _c.sent();
                    logger.log('Simulate tx failed', e_2);
                    return [3 /*break*/, 8];
                case 8:
                    logger.log(simulateResult);
                    if (simulateResult && simulateResult.err) {
                        if (simulateResult.logs) {
                            for (i = simulateResult.logs.length - 1; i >= 0; --i) {
                                line = simulateResult.logs[i];
                                if (line.startsWith('Program log: ')) {
                                    throw {
                                        message: 'Transaction failed: ' + line.slice('Program log: '.length),
                                        txid: txid,
                                    };
                                }
                            }
                        }
                        throw {
                            message: JSON.stringify(simulateResult.err),
                            txid: txid,
                        };
                    }
                    throw { message: 'Transaction failed', txid: txid };
                case 9:
                    done = true;
                    return [7 /*endfinally*/];
                case 10: return [2 /*return*/, txid];
            }
        });
    });
};
exports.sendAndConfirmSignedTransaction = sendAndConfirmSignedTransaction;
/**
 * sign and send array of transactions in desired batches with different styles of send for each array
 * @param timeoutStrategy
 *
 * BlockHeightStrategy: blockheight pool satrategy
 *
 *  startBlockCheckAfterSecs: optional, (secs) after that time we will start to pool current blockheight and check if transaction will reach blockchain, default: 90
 *  block: BlockhashWithExpiryBlockHeight
 *  getSignatureStatusesPoolIntervalMs: optional, (ms) pool interval of getSignatureStatues and blockheight, default: 2000
 *
 *
 * @param callbacks sets of callbacks
 * @param callbacks.afterFirstBatchSign callback will run only on first batch approval
 * @param callbacks.afterBatchSign callback will run on any batch approval
 * @param callbacks.afterAllTxConfirmed callback will run after all transaction batches are confirmed
 * @param callbacks.afterEveryTxConfirmation callback will run on every single transaction confirmation
 * @param callbacks.onError callback will run on error
 *
 * @param config.maxTxesInBatch max transactions in one batch of transactions, there is limitation on how much wallet can sign in one go depending on used wallet. default 40
 * @param config.autoRetry auto retry on any error approve and send of transaction after error
 * @param config.maxRetries if auto retry is true, it will try this amount of times before actual error, default 5
 * @param config.retired argument passed by recursive function best not to change it, default 0
 * @param config.logFlowInfo when true it will console log process of processing transactions
 */
var sendSignAndConfirmTransactions = function (_a) {
    var connection = _a.connection, wallet = _a.wallet, transactionInstructions = _a.transactionInstructions, _b = _a.confirmLevel, confirmLevel = _b === void 0 ? 'processed' : _b, timeoutStrategy = _a.timeoutStrategy, callbacks = _a.callbacks, _c = _a.config, config = _c === void 0 ? {
        maxTxesInBatch: 40,
        autoRetry: false,
        maxRetries: 5,
        retried: 0,
        logFlowInfo: false,
    } : _c;
    return __awaiter(void 0, void 0, void 0, function () {
        var logger, block, maxTransactionsInBath, currentTransactions, unsignedTxns, transactionCallOrchestrator, _loop_1, i, signedTxns, _i, transactionCallOrchestrator_1, fcn, _d, _e, idx, transactionIdx, transactionInstructionIdx, e_3, forwardedTransactions, e_4, idx, txInstructionForRetry, idx, txInstructionForRetry;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    logger = new tools_1.Logger(__assign({}, config));
                    block = timeoutStrategy === null || timeoutStrategy === void 0 ? void 0 : timeoutStrategy.block;
                    if (!wallet.publicKey)
                        throw new Error('Wallet not connected!');
                    if (!!block) return [3 /*break*/, 2];
                    return [4 /*yield*/, connection.getLatestBlockhash('confirmed')];
                case 1:
                    block = _f.sent();
                    _f.label = 2;
                case 2:
                    if (typeof (config === null || config === void 0 ? void 0 : config.retried) === 'undefined') {
                        config.retried = 0;
                    }
                    if (typeof (config === null || config === void 0 ? void 0 : config.maxRetries) === 'undefined') {
                        config.maxRetries = 5;
                    }
                    maxTransactionsInBath = config.maxTxesInBatch;
                    currentTransactions = transactionInstructions.slice(0, maxTransactionsInBath);
                    unsignedTxns = [];
                    transactionCallOrchestrator = [];
                    _loop_1 = function (i) {
                        var _g, _h;
                        var transactionInstruction = currentTransactions[i];
                        var signers = [];
                        if (transactionInstruction.instructionsSet.length === 0) {
                            return "continue";
                        }
                        var transaction = new web3_js_1.Transaction({ feePayer: wallet.publicKey });
                        transactionInstruction.instructionsSet.forEach(function (instruction) {
                            var _a;
                            transaction.add(instruction.transactionInstruction);
                            if ((_a = instruction.signers) === null || _a === void 0 ? void 0 : _a.length) {
                                signers.push.apply(signers, instruction.signers);
                            }
                        });
                        transaction.recentBlockhash = block.blockhash;
                        if (signers === null || signers === void 0 ? void 0 : signers.length) {
                            transaction.partialSign.apply(transaction, signers);
                        }
                        //we take last index of unsignedTransactions to have right indexes because
                        //if transactions was empty
                        //then unsigned transactions could not mach TransactionInstructions param indexes
                        var currentUnsignedTxIdx = unsignedTxns.length;
                        var currentTransactionCall = transactionCallOrchestrator[transactionCallOrchestrator.length - 1];
                        //we check if last item in current transactions call type is same
                        //if not then we create next transaction type
                        if (currentTransactionCall && currentTransactionCall.sequenceType === transactionInstruction.sequenceType) {
                            //we push reflection of transactionInstruction as object value for retry.
                            currentTransactionCall.transactionsIdx.push((_g = {},
                                _g[currentUnsignedTxIdx] = i,
                                _g));
                        }
                        else {
                            transactionCallOrchestrator.push({
                                //we push reflection of transactionInstruction as object value for retry.
                                transactionsIdx: [(_h = {}, _h[currentUnsignedTxIdx] = i, _h)],
                                sequenceType: transactionInstruction.sequenceType,
                            });
                        }
                        unsignedTxns.push(transaction);
                    };
                    for (i = 0; i < currentTransactions.length; i++) {
                        _loop_1(i);
                    }
                    logger.log(transactionCallOrchestrator);
                    return [4 /*yield*/, wallet.signAllTransactions(unsignedTxns)];
                case 3:
                    signedTxns = _f.sent();
                    if (callbacks === null || callbacks === void 0 ? void 0 : callbacks.afterFirstBatchSign) {
                        callbacks.afterFirstBatchSign(signedTxns.length);
                    }
                    else if (callbacks === null || callbacks === void 0 ? void 0 : callbacks.afterBatchSign) {
                        callbacks.afterBatchSign(signedTxns.length);
                    }
                    logger.log('Transactions play type order', transactionCallOrchestrator.map(function (x) {
                        return __assign(__assign({}, x), { sequenceType: typeof x.sequenceType !== 'undefined' ? globalTypes_1.SequenceType[Number(x.sequenceType)] : 'Parallel' });
                    }));
                    logger.log('Signed transactions', signedTxns);
                    _f.label = 4;
                case 4:
                    _f.trys.push([4, 17, , 23]);
                    _i = 0, transactionCallOrchestrator_1 = transactionCallOrchestrator;
                    _f.label = 5;
                case 5:
                    if (!(_i < transactionCallOrchestrator_1.length)) return [3 /*break*/, 14];
                    fcn = transactionCallOrchestrator_1[_i];
                    if (!(typeof fcn.sequenceType === 'undefined' || fcn.sequenceType === globalTypes_1.SequenceType.Parallel)) return [3 /*break*/, 7];
                    //wait for all Parallel
                    return [4 /*yield*/, Promise.all(fcn.transactionsIdx.map(function (idx) {
                            var transactionIdx = Number(Object.keys(idx)[0]);
                            var transactionInstructionIdx = idx[transactionIdx];
                            return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
                                var resp, e_5;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, (0, exports.sendAndConfirmSignedTransaction)({
                                                    connection: connection,
                                                    signedTransaction: signedTxns[transactionIdx],
                                                    confirmLevel: confirmLevel,
                                                    timeoutStrategy: {
                                                        block: block,
                                                    },
                                                    callbacks: {
                                                        afterTxConfirmation: callbacks === null || callbacks === void 0 ? void 0 : callbacks.afterEveryTxConfirmation,
                                                    },
                                                    config: config,
                                                })];
                                        case 1:
                                            resp = _a.sent();
                                            resolve(resp);
                                            return [3 /*break*/, 3];
                                        case 2:
                                            e_5 = _a.sent();
                                            logger.log(e_5);
                                            if (typeof e_5 === 'object') {
                                                reject(__assign(__assign({}, e_5), { transactionInstructionIdx: transactionInstructionIdx }));
                                            }
                                            else {
                                                reject(e_5);
                                            }
                                            return [3 /*break*/, 3];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); });
                        }))];
                case 6:
                    //wait for all Parallel
                    _f.sent();
                    _f.label = 7;
                case 7:
                    if (!(fcn.sequenceType === globalTypes_1.SequenceType.Sequential)) return [3 /*break*/, 13];
                    _d = 0, _e = fcn.transactionsIdx;
                    _f.label = 8;
                case 8:
                    if (!(_d < _e.length)) return [3 /*break*/, 13];
                    idx = _e[_d];
                    transactionIdx = Number(Object.keys(idx)[0]);
                    transactionInstructionIdx = idx[transactionIdx];
                    _f.label = 9;
                case 9:
                    _f.trys.push([9, 11, , 12]);
                    return [4 /*yield*/, (0, exports.sendAndConfirmSignedTransaction)({
                            connection: connection,
                            signedTransaction: signedTxns[transactionIdx],
                            confirmLevel: confirmLevel,
                            timeoutStrategy: {
                                block: block,
                            },
                            callbacks: {
                                afterTxConfirmation: callbacks === null || callbacks === void 0 ? void 0 : callbacks.afterEveryTxConfirmation,
                            },
                            config: config,
                        })];
                case 10:
                    _f.sent();
                    return [3 /*break*/, 12];
                case 11:
                    e_3 = _f.sent();
                    logger.log(e_3);
                    if (typeof e_3 === 'object') {
                        throw __assign(__assign({}, e_3), { transactionInstructionIdx: transactionInstructionIdx });
                    }
                    else {
                        throw e_3;
                    }
                    return [3 /*break*/, 12];
                case 12:
                    _d++;
                    return [3 /*break*/, 8];
                case 13:
                    _i++;
                    return [3 /*break*/, 5];
                case 14:
                    if (!(transactionInstructions.length > maxTransactionsInBath)) return [3 /*break*/, 16];
                    forwardedTransactions = transactionInstructions.slice(maxTransactionsInBath, transactionInstructions.length);
                    return [4 /*yield*/, (0, exports.sendSignAndConfirmTransactions)({
                            connection: connection,
                            wallet: wallet,
                            confirmLevel: confirmLevel,
                            transactionInstructions: forwardedTransactions,
                            timeoutStrategy: timeoutStrategy,
                            callbacks: {
                                afterBatchSign: callbacks === null || callbacks === void 0 ? void 0 : callbacks.afterBatchSign,
                                afterAllTxConfirmed: callbacks === null || callbacks === void 0 ? void 0 : callbacks.afterAllTxConfirmed,
                                afterEveryTxConfirmation: callbacks === null || callbacks === void 0 ? void 0 : callbacks.afterEveryTxConfirmation,
                                onError: callbacks === null || callbacks === void 0 ? void 0 : callbacks.onError,
                            },
                            config: config,
                        })];
                case 15:
                    _f.sent();
                    _f.label = 16;
                case 16:
                    if (callbacks === null || callbacks === void 0 ? void 0 : callbacks.afterAllTxConfirmed) {
                        callbacks.afterAllTxConfirmed();
                    }
                    return [3 /*break*/, 23];
                case 17:
                    e_4 = _f.sent();
                    logger.log(e_4);
                    if (callbacks === null || callbacks === void 0 ? void 0 : callbacks.onError) {
                        if (typeof e_4 === 'object') {
                            idx = e_4.txInstructionIdx;
                            txInstructionForRetry = transactionInstructions.slice(idx, transactionInstructions.length);
                            callbacks.onError(e_4, txInstructionForRetry, {
                                connection: connection,
                                wallet: wallet,
                                confirmLevel: confirmLevel,
                                transactionInstructions: transactionInstructions,
                                timeoutStrategy: timeoutStrategy,
                                callbacks: callbacks,
                                config: config,
                            });
                        }
                        else {
                            callbacks.onError(e_4, [], {
                                connection: connection,
                                wallet: wallet,
                                confirmLevel: confirmLevel,
                                transactionInstructions: transactionInstructions,
                                timeoutStrategy: timeoutStrategy,
                                callbacks: callbacks,
                                config: config,
                            });
                        }
                    }
                    if (!(config.autoRetry && config.maxRetries < config.retried)) return [3 /*break*/, 21];
                    idx = e_4 === null || e_4 === void 0 ? void 0 : e_4.txInstructionIdx;
                    if (!(typeof idx !== 'undefined')) return [3 /*break*/, 19];
                    config.retried++;
                    txInstructionForRetry = transactionInstructions.slice(idx, transactionInstructions.length);
                    return [4 /*yield*/, (0, exports.sendSignAndConfirmTransactions)({
                            connection: connection,
                            wallet: wallet,
                            confirmLevel: confirmLevel,
                            transactionInstructions: txInstructionForRetry,
                            callbacks: callbacks,
                            config: config,
                        })];
                case 18:
                    _f.sent();
                    return [3 /*break*/, 20];
                case 19: throw e_4;
                case 20: return [3 /*break*/, 22];
                case 21: throw e_4;
                case 22: return [3 /*break*/, 23];
                case 23: return [2 /*return*/];
            }
        });
    });
};
exports.sendSignAndConfirmTransactions = sendSignAndConfirmTransactions;
/** Copy of Connection.simulateTransaction that takes a commitment parameter. */
function simulateTransaction(connection, transaction, commitment, logInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var logger, latestBlockhash, signData, wireTransaction, encodedTransaction, config, args, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    logger = new tools_1.Logger({ logFlowInfo: !!logInfo });
                    return [4 /*yield*/, connection.getLatestBlockhash()];
                case 1:
                    latestBlockhash = _a.sent();
                    transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                    transaction.recentBlockhash = latestBlockhash.blockhash;
                    logger.log('simulating transaction', transaction);
                    signData = transaction.serializeMessage();
                    wireTransaction = transaction._serialize(signData);
                    encodedTransaction = wireTransaction.toString('base64');
                    logger.log('encoding');
                    config = { encoding: 'base64', commitment: commitment };
                    args = [encodedTransaction, config];
                    logger.log('simulating data', args);
                    return [4 /*yield*/, connection._rpcRequest('simulateTransaction', args)];
                case 2:
                    res = _a.sent();
                    logger.log('res simulating transaction', res);
                    if (res.error) {
                        throw new Error('failed to simulate transaction: ' + res.error.message);
                    }
                    return [2 /*return*/, res.result];
            }
        });
    });
}
exports.simulateTransaction = simulateTransaction;
